import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import { Translate as t } from '../../config/Translate';
import { isAdminContextPath } from '../../lib/loginRedirect';

// U-23: 정의되지 않은 경로 진입 시 빈 화면 대신 보여주는 안내 화면.
// 로그인 사용자 전용 — app.js 에서 AuthRoute(경로 없음)로 감싸 두 Switch 의 마지막에 둔다.
// 관리자 컨텍스트 판정은 app.js computeLayoutFlags 와 동일 SSoT(isAdminContextPath).
const NotFound = () => {
	const location = useLocation();
	const homePath = isAdminContextPath(location?.pathname) ? ROUTES.ADMIN_DASHBOARD : ROUTES.HOME;

	return (
		<div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
			<div className="text-center p-4">
				<h2 className="mb-3">{t('common.notFound.title')}</h2>
				<p className="text-muted mb-4">{t('common.notFound.message')}</p>
				<Link to={homePath} className="btn btn-primary">{t('common.notFound.goHome')}</Link>
			</div>
		</div>
	);
};

export default NotFound;
